import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CompanyColumn = ({ customerId }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  const { address = {} } = customer || {};
  const company = (address && address.company) || '';

  return company;
};

export const Company = {
  getMessageDescriptor: () => messages.company,
  id: 'company',

  render: ({ customerId }) => {
    return <CompanyColumn customerId={customerId} />;
  },
};
